<h1 mat-dialog-title style="font-weight: bold">Warning</h1>
<div mat-dialog-content>
  By clicking OK you'll close the details window and remove this transaction from the list of cancellations for your current identity.
</div>
<div mat-dialog-actions style="justify-content: flex-end">
  <button mat-button (click)="onNoClick()">CANCEL</button>
  <button mat-button [mat-dialog-close]="{ close: true }" cdkFocusInitial>OK</button>
</div>
